var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtnMob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 8,
    transform: "rotate(180 40 40)",
    fill: "#333217"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1505_6344",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1505_6344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 21.4L15.1 26.3C14.9167 26.4833 14.6834 26.575 14.4 26.575C14.1167 26.575 13.8834 26.4833 13.7 26.3C13.5167 26.1167 13.425 25.8833 13.425 25.6C13.425 25.3167 13.5167 25.0833 13.7 24.9L18.6 20L13.7 15.1C13.5167 14.9167 13.425 14.6833 13.425 14.4C13.425 14.1167 13.5167 13.8833 13.7 13.7C13.8834 13.5167 14.1167 13.425 14.4 13.425C14.6834 13.425 14.9167 13.5167 15.1 13.7L20.0001 18.6L24.9001 13.7C25.0834 13.5167 25.3167 13.425 25.6001 13.425C25.8834 13.425 26.1167 13.5167 26.3001 13.7C26.4834 13.8833 26.5751 14.1167 26.5751 14.4C26.5751 14.6833 26.4834 14.9167 26.3001 15.1L21.4 20L26.3001 24.9C26.4834 25.0833 26.5751 25.3167 26.5751 25.6C26.5751 25.8833 26.4834 26.1167 26.3001 26.3C26.1167 26.4833 25.8834 26.575 25.6001 26.575C25.3167 26.575 25.0834 26.4833 24.9001 26.3L20.0001 21.4Z",
    fill: "#EAD40C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtnMob);
export default __webpack_public_path__ + "static/media/close-btn-mob.47ea77c98162e6e739822fc57f7da3ec.svg";
export { ForwardRef as ReactComponent };